module.exports = __webpack_public_path__ + "static/media/arrow_top.a28720fe.png";